<template>
  <div class="hello">
    <h1>ポストエクスプレス<span>&reg;</span> WEB（栃木県央版）</h1>
    <p>
      配布したいエリアを選択して、「詳細エリア選択」ボタンを押してください。<br>
      週稼働エリアと月稼働エリアは同時に選択できません。<br>
      ※1 発注できる部数は受注状況により下記の受注可能数以下になることがあります。<br>
      ※2 エリア名をクリックすると当該配布エリア表[pdf]が表示されます。
    </p>
    <div class="wrapper">
      <h3>週稼働エリア</h3>
      <el-table
        ref="weeklyAreaTbl"
        :data="week_area"
        @selection-change="handleWeeklyAreaSelectionChange"
      >
        <el-table-column
          property="pref"
          label="県名"
          width="120"
        >
        </el-table-column>
        <el-table-column
          property="area"
          label="エリア"
          width="120"
        >
        <template #default="scope">
          <el-link :href="scope.row.href" target="_blank">{{ scope.row.area }}</el-link>
        </template>
        </el-table-column>
        <el-table-column
          type="selection"
          width="55"
        >
        </el-table-column>
        <el-table-column
          property="operate"
          label="稼働期間"
        >
        </el-table-column>
        <el-table-column
          property="dlimit"
          label="納品締切"
        >
        </el-table-column>
        <el-table-column
          property="limit"
          label="受注可能数"
          width="100"
        >
        </el-table-column>
      </el-table>
      <h3>月稼働エリア</h3>
      <el-table
        ref="monthlyAreaTbl"
        :data="month_area"
        @selection-change="handleMonthlyAreaSelectionChange"
      >
        <el-table-column
          property="pref"
          label="県名"
          width="120"
        >
        </el-table-column>
        <el-table-column
          property="area"
          label="エリア"
          width="120"
        >
        <template #default="scope">
          <el-link :href="scope.row.href" target="_blank">{{ scope.row.area }}</el-link>
        </template>
        </el-table-column>
        <el-table-column
          type="selection"
          width="55"
        >
        </el-table-column>
        <el-table-column
          property="operate"
          label="稼働期間"
        >
        </el-table-column>
        <el-table-column
          property="dlimit"
          label="納品締切"
        >
        </el-table-column>
        <el-table-column
          property="limit"
          label="受注可能数"
          width="100"
        >
        </el-table-column>
      </el-table>
      <p class="right small">※ 4エリアの合計／回</p>
      <el-button type="primary" round @click="deteilAreas">詳細エリア選択</el-button>
    </div>
    <h3>Navi</h3>
    <ul>
      <li><router-link to="/about">このサイトについて</router-link></li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router'
import { app } from '../main';
import { IAreaSelection } from '@/types/IAreaSelection';
import { week_area, month_area } from '../operation_area';

export default defineComponent({
  name: 'HelloWorld',
  props: {
    msg: String,
  },
  setup() {
    const router = useRouter()
    const weeklyAreaTbl = ref()
    const monthlyAreaTbl = ref()
    const AreaSelection: ({ weekly: IAreaSelection[], monthly: IAreaSelection[] } | undefined) = inject('area_selection')
    const handleWeeklyAreaSelectionChange = (val: any) => {
      if(AreaSelection) {
        AreaSelection.weekly = val
      }
    }
    const handleMonthlyAreaSelectionChange = (val: any) => {
      if(AreaSelection) {
        AreaSelection.monthly = val
      }
    }

    const deteilAreas = () => {
      if(AreaSelection) {
        if(AreaSelection.weekly.length > 0 && AreaSelection.monthly.length > 0) {
          app.config.globalProperties.$notify({
            title: 'Warning',
            message: '週稼働エリアと月稼働エリアは同時に選択できません。',
            type: 'warning'
          });
        }else if(AreaSelection.weekly.length + AreaSelection.monthly.length == 0) {
          app.config.globalProperties.$notify({
            title: 'Warning',
            message: 'エリアが選択されていません。',
            type: 'warning'
          });
        }else {
          sessionStorage.setItem('AreaSelection', JSON.stringify(AreaSelection));
          router.push('/map')
        }
      }
    }

    onMounted(() => {
      if(AreaSelection) {
        if(AreaSelection.weekly.length > 0) {
          AreaSelection.weekly.forEach(row => {
            weeklyAreaTbl.value.toggleRowSelection(week_area.find(elem => elem.area == row.area))
          })
        }else {
          weeklyAreaTbl.value.clearSelection()
        }
        if(AreaSelection.monthly.length > 0) {
          AreaSelection.monthly.forEach(row => {
            monthlyAreaTbl.value.toggleRowSelection(month_area.find(elem => elem.area == row.area))
          })
        }else {
          monthlyAreaTbl.value.clearSelection()
        }
      }
    })

    return {
      week_area,
      month_area,
      deteilAreas,
      weeklyAreaTbl,
      monthlyAreaTbl,
      handleWeeklyAreaSelectionChange,
      handleMonthlyAreaSelectionChange
    }
  }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 span {
  vertical-align: super;
  font-size: smaller;
}
.wrapper {
  width: 80%;
  margin: 0 auto;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  /*display: inline-block;*/
  margin: 0 10px;
}
a {
  color: #43b665;
}
.el-button {
  margin-top: 20px;
}
.hello .right {
  text-align: right;
}
.small {
  font-size: smaller;
}
</style>
